module.exports = __webpack_public_path__ + "static/media/topography.bd408c35.svg";